<template>
  <div class="card shadow-sm border-0 h-100">
    <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div>
        <strong>{{ title }}</strong>
        <div class="small text-muted">
          <slot name="range">{{ rangeText }}</slot>
        </div>
      </div>
      <div class="d-flex gap-2 flex-wrap">
        <button
          v-if="showInfo"
          class="btn btn-sm btn-outline-info"
          :disabled="infoDisabled"
          @click="$emit('info')"
        >
          <i class="bi bi-info-circle me-1"></i>
          Info
        </button>
        <slot name="header-actions"></slot>
        <button
          v-if="showRefresh"
          class="btn btn-sm btn-outline-secondary"
          :disabled="refreshDisabled"
          @click="$emit('refresh')"
        >
          {{ refreshLabel }}
        </button>
      </div>
    </div>

    <div class="card-body">
      <div v-if="loading" class="analytics-loading">
        <slot name="loading">
          <div class="analytics-skeleton-wrap">
            <div
              v-for="index in skeletonRows"
              :key="`analytics-skeleton-${index}`"
              class="analytics-skeleton-row"
              :class="{ short: index % 3 === 0 }"
            ></div>
          </div>
        </slot>
      </div>
      <div v-else-if="error" class="alert alert-danger mb-0">
        {{ error }}
      </div>
      <div v-else>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyticsSectionCard",
  emits: ["info", "refresh"],
  props: {
    title: {
      type: String,
      required: true,
    },
    rangeText: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    infoDisabled: {
      type: Boolean,
      default: false,
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
    refreshDisabled: {
      type: Boolean,
      default: false,
    },
    refreshLabel: {
      type: String,
      default: "Refresh",
    },
    skeletonRows: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style scoped>
.card-header {
  background: #f8f9fa;
}

.analytics-loading {
  min-height: 240px;
}

.analytics-skeleton-wrap {
  display: grid;
  gap: 0.55rem;
  padding: 0.15rem 0.1rem;
}

.analytics-skeleton-row {
  height: 0.82rem;
  border-radius: 0.35rem;
  background: linear-gradient(90deg, #e9ecef 0%, #f8f9fa 50%, #e9ecef 100%);
  background-size: 220% 100%;
  animation: analytics-shimmer 1.2s linear infinite;
}

.analytics-skeleton-row.short {
  width: 72%;
}

@keyframes analytics-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
